import { apiRequest } from "@services/apiClient";
import tourBoundariesEndpoints from "@services/tourBoundaries/tourBoundariesEndpoints";

export function syncTourBoundariesRequest(payload) {
  return apiRequest(tourBoundariesEndpoints.base, {
    method: "POST",
    body: payload,
  });
}

export function listTourBoundariesByTourRequest(tourId) {
  return apiRequest(tourBoundariesEndpoints.byTour(tourId));
}

export function normalizeBoundaryPointFromApi(point = {}) {
  return {
    id: String(point?.id || `boundary-${point?.pointOrder || point?.order || 0}`),
    order: Number(point?.pointOrder ?? point?.order ?? 0) || 0,
    lng: Number(point?.longitude ?? 0),
    lat: Number(point?.latitude ?? 0),
  };
}

